<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>办件进度</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="schedule">
            <h2 class="tit8"  ><span><img src="../../../static/images/guide_sign11.png"> 办件进度查询</span></h2>
            <div class="schedule_sea2">
             <!--   <el-input
                  placeholder="请输入办件编号/身份证号"
                  v-model="person_uid" style="width: 450px;">
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>-->
              <template>
                <el-select style="width: 450px" v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in relationList"
                    :key="item.value"
                    :label="item.name+'（'+item.user_idcard+'）'"
                    :value="item.user_idcard_no_occlude">
                  </el-option>
                </el-select>
              </template>
              <el-button type="primary"   @click="onSearch"  icon="el-icon-search">搜索</el-button>

            </div>
            <div class="clear"></div>
            <div v-if="!dataList || dataList.length<=0" style="height: 200px;">
            </div>
            <div v-if="dataList && dataList.length>0">


              <div style="width: 80%;margin: 0 auto;"  v-for="(item,index) in dataList" :key="index">
              <div style="width: 100%;margin: 0 auto;font-size: 14px;margin-top: 15px;height: 30px;line-height: 30px;margin-bottom: 5px;"><el-button style="float: right;width: 90px;height: 30px;line-height: 30px;padding: 0px;" type="primary"  @click="showDialog(item)">办件详细</el-button></div>
              <table align="center" style="width: 100%;border: 1px solid  #dbdbdb;border-bottom: 0px;font-size: 14px;border-collapse:collapse">
                <tr><td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 80px;text-align: right;height: 30px;    background-color: #e4e7ed;">申报人名：</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 150px;text-align: left;font-size: 13px;font-size: 13px;color:#888888;">&nbsp;{{item.userName}}</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 80px;text-align: right;    background-color: #e4e7ed;">身份证号：</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 150px;text-align: left;font-size: 13px;color:#888888;">&nbsp;{{item.userIdCard}}</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;width: 80px;text-align: right;    background-color: #e4e7ed;">申报编号：</td>
                  <td style="border-bottom: 1px solid  #dbdbdb;text-align: left;font-size: 13px;color:#888888;">&nbsp;{{item.applyNo}}</td>
                </tr>
                <tr>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: right;height: 30px;    background-color: #e4e7ed;">申报业务：</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: left;font-size: 13px;color:#888888;">&nbsp;{{item.archiveTypeName}}</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: right;    background-color: #e4e7ed;">申请时间：</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: left;font-size: 13px;color:#888888;">&nbsp;{{item.applyDate}}</td>
                  <td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: right;    background-color: #e4e7ed;">受理状态：</td>
                  <td style="border-bottom: 1px solid  #dbdbdb;text-align: left;font-size: 13px;color:#888888;">&nbsp;
                    <span v-if="item.flowStatus == '0'">待签收</span>
                    <span v-if="item.flowStatus == '1'">受理中</span>
                    <span v-if="item.flowStatus == '2'">审核中</span>
                    <span v-if="item.flowStatus == '3'">{{item.applyStatusName}}</span>
                  </td>
                </tr>
                <tr><td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: right;height: 30px;    background-color: #e4e7ed;">受理单位：</td>
                  <td colspan="5" style="border-bottom: 1px solid  #dbdbdb;width: 100px;text-align: left;padding:5px;font-size: 13px;color:#888888;">{{item.toPartyId}}</td></tr>
                <tr><td style="border-right: 1px solid  #dbdbdb;border-bottom: 1px solid  #dbdbdb;text-align: right;height: 30px;    background-color: #e4e7ed;">申报原因：</td>
                  <td colspan="5" style="border-bottom: 1px solid  #dbdbdb;width: 100px;text-align: left;padding:5px;font-size: 13px;color:#888888;">{{item.userMemo}}</td></tr>
              </table>
              </div>
              <div style="width: 100%;height: 50px;"></div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog_css11" v-if="dialogVisible">
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      >
      <div style="width: 100%;height: 30px;"></div>
      <div style="width: 80%;margin: 0 auto;font-size: 14px;margin-top: 15px;height: 30px;line-height: 30px;">办理进度：</div>
      <div style="width: 80%;margin: 0 auto;font-size: 14px;line-height: 30px;border: 1px solid  #dbdbdb;padding: 20px 0px;">
        <el-steps :active="getCurrentStep(items)"  align-center="">
          <el-step style="font-size: 10px">
            <template slot="title">
              <span style="font-size:10px">提交申请</span>
            </template>
            <template slot="description">
              <span style="font-size:10px">{{items.applyDate}}</span>
            </template>
          </el-step>
          <el-step style="font-size: 10px">
            <template slot="title">
              <span style="font-size:10px" v-if="items.flowStatus<1">待受理</span>
              <span style="font-size:10px" v-if="items.flowStatus==1">受理中</span>
              <span style="font-size:10px" v-if="items.flowStatus>1">已受理</span>
            </template>
            <template slot="description">
              <span style="font-size:10px"></span>
            </template>
          </el-step>
          <el-step style="font-size: 10px">
            <template slot="title">
              <span style="font-size:10px" v-if="items.flowStatus<2">待审批</span>
              <span style="font-size:10px" v-if="items.flowStatus==2">审批中</span>
              <span style="font-size:10px" v-if="items.flowStatus>2">已审批</span>
            </template>
            <template slot="description">
              <span style="font-size:10px"></span>
            </template>
          </el-step>
          <el-step style="font-size: 10px">
            <template slot="title">
              <span style="font-size:10px">{{getFinalStep(items)}}</span>
            </template>
            <template slot="description">
              <span style="font-size:10px"></span>
            </template>
          </el-step>
        </el-steps>

      </div>
      <div style="width: 80%;margin: 0 auto;font-size: 14px;margin-top: 15px;height: 30px;line-height: 30px;">办理记录：</div>
      <div style="width: 80%;margin: 0 auto;font-size: 14px;border: 1px solid  #dbdbdb;padding: 20px 0px;" class="stepDivCss22">
        <el-steps direction="vertical" :active="-1" space="60px" style="margin-top: 10px;margin-left: 20px;">
          <el-step v-for="(logs, indexs) in items.logData" :key="items.logId" :title="'【'+logs.optStatusName+'】'+logs.optPartyId">
            <template slot="description">
              <div style="padding-left: 20px;">
                {{logs.optTime}}<br />
                {{logs.optDesc}}
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "PayList", components: {
      headers, fixedDiv, footers
    },
    mounted() {
      var ttt=this;
      this.$https.post("api/pu/peopleUserInfo.do",{},response=> {
        if (response.status === 200 && response.data.code === 200) {
          if (response.data.data.isCertification == '1') {
            ttt.person_uid = response.data.data.userIdcard;
            ttt.onSearch();
          }
        }
      })
      this.selectRelation();
    },
    data() {
      return {
        dataList: [],
        dialogVisible:false,
        relationList:'',
        value:'',
        person_uid:'',
        items:{}
      }
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      showDialog(item){
        this.dialogVisible=true;
        this.items=item
      },
      //获取最后一个步骤的名称
      getFinalStep(item) {
        if (item.flowStatus === "3") {
          return item.applyStatusName
        } else {
          return '审批结束'
        }
      },
      //判断当前处于第几个步骤
      getCurrentStep(item) {
        return parseInt(item.flowStatus) + 1
      },
      selectRelation(){
        const options={
        }
        //查找用户关系
        this.$https.post("api/choice/selectRelationAll.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.relationList=response.data.data;
          } else {
            // t.departOption =[];
          }
        })
      },
      onSearch(t){
        if (!this.$util.isEmpty(this.value)){
          this.person_uid=this.value
        }
          if(this.person_uid==''){
            return false;
          }
        this.$https.post("api/apply/getApplyList.do",{searchValue:this.person_uid,fromType:'web'},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data!==null) {
            this.dataList=response.data.data.filter(bean=>{
              return bean.flowStatus !='-1'
              // return bean.status!==99
            });
          } else {
            // this.$router.push({path:'/peopleLogin'});
            this.$message.error('未查询到改身份证的办件信息，请检查输入是否有误');
            this.dataList=[]

          }
        })
      },
    },
  }
</script>

<style>
  .stepDivCss22 .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss22 .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #303133;
  }

  .dialog_css11 .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css11 .el-dialog__header {
    padding: 0px;
  }
  .dialog_css11 .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-size: 20px;
    font-weight: 900;
  }
</style>



// WEBPACK FOOTER //
// src/pages/usualservice/ApplyList.vue